<template>
	<table>
		<PatientRowHead :active-columns="activeColumns" type="error"></PatientRowHead>
		<tbody>
			<PatientRow v-for="(patient, index) in patients"
				v-bind:key="'error' + index"
				v-model="patient.data"
				v-bind:error="patient.error"
				:active-columns="activeColumns"
				@remove="removeRow(index)">
			</PatientRow>
			<tr>
				<td class="add-row" colspan="4">
					<button class="btn btn-link"
						@click="addRow">
						<AddRowIcon></AddRowIcon>
						Add another
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</template>

<script>
import PatientList from './mixin/patient-list'
import PatientRowHead from '../head/Patient'
import PatientRow from '../row/Patient'
import AddRowIcon from '../icons/AddRow'
export default {
	name: 'patient-error-table',
	mixins: [ PatientList ],
	components: {
		PatientRowHead,
		PatientRow,
		AddRowIcon
	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>
